
import React from 'react'
import NavbarSection from '../NavbarSection/NavbarSection';
import heroimage from "../../assets/heroimage.png"

import "./HeroSection.css";
import HomeData from '../HomeData/HomeData';
const HeroSection = () => {
    return (
      <div
        className="main-home-image-section-div"
        style={{ backgroundImage: `url(${heroimage})` }}
      >
            <NavbarSection />
           <HomeData/>
      </div>
    );
}

export default HeroSection